import ResetPasswordForShopRequestModelBase from '../_generated/modelBases/reset-password-for-shop-request-model-base';

export default class ResetPasswordForShopRequestModel extends ResetPasswordForShopRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
